import {styled} from "@mui/material";

export const StaticBarContainer = styled('div')({
  backgroundColor: '#F7F9FC',
  overflow: 'hidden',
  height: '100%',
});
